module.exports = __webpack_public_path__ + "img/contect.c84e2049.svg";